// assets
import { IconUsers  } from '@tabler/icons';


// constant
const icons = {
    IconUsers 
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const subOwners = {
    id: 'subOwners',
    type: 'group',
    children: [
        {
            id: 'subOwners',
            title: 'Sub Owners',
            type: 'item',
            icon: icons.IconUsers ,
            url: '/master-management/subAccounts',

            // children: [
            //     {
            //         id: 'subAccounts',
            //         title: 'Sub Accounts',
            //         type: 'item',
            //         url: '/master-management/subAccounts',
            //         breadcrumbs: true
            //     },
            //     {
            //         id: 'createSubAccount',
            //         title: 'Create Sub Account',
            //         type: 'item',
            //         url: '/master-management/createSubAccount',
            //         breadcrumbs: true
            //     }
            // ]
        }
    ]
};

export default subOwners;
